import { CheckIcon } from '@assets/icons/CheckIcon';
import { ClearIcon } from '@assets/icons/ClearIcon';
import info from '@assets/icons/info.svg';
import { TaAutocomplete, TaInput } from '@components/shared';
import { GeneralMuiModal } from '@components/shared/general-mui-modal';
import CustomTooltip from '@components/tooltip/tooltip';
import { theme } from '@config/theme';
import { PaymentCard } from '@features/requests/requestModal/paymentCard';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import {
	Button,
	CardMedia,
	Checkbox,
	Chip,
	FormControlLabel,
	IconButton,
	TextField,
} from '@mui/material';
import { Dictionary, Nullable } from '@utils/util.types';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import attachments from '../../../assets/icons/attachments.svg';
import browse from '../../../assets/icons/browse.svg';
import exel from '../../../assets/icons/exel.svg';
import pdf from '../../../assets/icons/pdf.svg';
import userIcon from '../../../assets/icons/userPrimary.svg';
import word from '../../../assets/icons/word.svg';
import melon from '../../../assets/melon.jpg';
import userTemp from '../../../assets/user.png';
import zgmartli from '../../../assets/zgmartli.jpg';

const statusChipStyle = {
	color: theme.palette.custom.contrastTextWhite,
	backgroundColor: '#FD7B33',
	borderRadius: '8px',
	border: '1px solid #FD7B33',
	height: '24px',
	'& .MuiChip-label': {
		color: theme.palette.custom.contrastTextWhite,
		padding: '1px 10px',
	},
};

// const chipStyle = {
// 	color: theme.palette.custom.darkGray,
// 	borderRadius: '8px',
// 	height: '22px',
// 	border: '1px solid text-disabled',
// 	'& .MuiChip-label': {
// 		color: theme.palette.custom.darkGray,
// 	},
// };

const currencyOptions: Dictionary[] = [
	{
		name: 'EUR',
		id: 'eur',
	},
	{
		name: 'USD',
		id: 'usd',
	},
];

const data = {
	files: [
		{ name: 'document1.pdf', type: 'pdf' },
		{ name: 'spreadsheet1.xlsx', type: 'xlsx' },
		{ name: 'presentation1.docx', type: 'docx' },
		{ name: 'map1.kml', type: 'kml' },
		{ name: 'map2.kmx', type: 'kmx' },
	],
	resources: [
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
		{ name: melon },
		{ name: zgmartli },
	],
};

export const getIcon = (type: string): string | undefined => {
	switch (type) {
		case 'pdf':
			return pdf;
		case 'xlsx':
			return exel;
		case 'docx':
			return word;
		case 'kml':
		case 'kmx':
			return browse;
		default:
			return attachments;
	}
};

interface IncomingRequestsProps {
	hideActions?: boolean;
}

interface UnitInfo {
	name: Nullable<Dictionary>;
	count: string;
	id: string;
	price_checked: boolean;
	area_checked: boolean;
	consultation_checked: boolean;
}

const unitValidationSchema = Yup.object().shape({
	unit_name: Yup.string().required('fieldNameError'),
	unit_count: Yup.string().required('fieldNameError'),
	unit_id: Yup.object().required('fieldNameError'),
});

const initialValues: UnitInfo = {
	name: {
		name: 'EUR',
		id: 'eur',
	},
	count: 'EUR',
	id: 'eur',
	price_checked: false,
	area_checked: false,
	consultation_checked: false,
};

export const IncomingRequests: React.FC<IncomingRequestsProps> = ({ hideActions = false }) => {
	const { t } = useTranslation();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [comment, setComment] = useState('');
	const [isPaymentCardOpen, setIsPaymentCardOpen] = useState(false);
	const { navigateWithLanguage } = useLanguageNavigate();

	const maxChars = 1000;

	const handleSendOfferClick = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
		formik.resetForm();
	};

	const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (e.target.value.length <= maxChars) {
			setComment(e.target.value);
		}
	};

	const formik = useFormik<UnitInfo>({
		initialValues: initialValues,
		validationSchema: unitValidationSchema,
		onSubmit: (values) => console.log(values),
	});

	const handleReSendOfferClick = () => {
		setIsPaymentCardOpen(true);
	};

	const handleClosePaymentCard = () => {
		setIsPaymentCardOpen(false);
	};
	const checkboxFields = [
		{
			label: 'planted',
			name: 'planted',
			checked: true,
		},
		{
			label: 'weather_station',
			name: 'weather_station',
			checked: false,
		},
		{
			label: 'irrigation_water',
			name: 'irrigation_water',
			checked: true,
		},
		{
			label: 'irrigation_system',
			name: 'irrigation_system',
			checked: true,
		},
		{
			label: 'sensors',
			name: 'sensors',
			checked: true,
		},
		{
			label: 'management_soft',
			name: 'management_soft',
			checked: true,
		},
		{
			label: 'greenhouse',
			name: 'greenhouse',
			checked: true,
		},
	];

	return (
		<div className="flex flex-col gap-[20px] pb-5">
			<div className="flex gap-[22px]">
				<div className="relative">
					<CardMedia
						component="img"
						image={userTemp}
						alt="Blueberry"
						sx={{
							width: 74,
							height: 74,
							borderRadius: '12px',
							boxShadow: theme.boxShadows.primary,
						}}
					/>
					<div className="absolute  bottom-[-10px] right-[-10px] flex items-center justify-center rounded-lg bg-custom-yellow p-1.5 text-white cursor-pointer h-6 w-6 text-xs">
						<EditOutlinedIcon className="!text-[14px]" />
					</div>
				</div>
				<div className="flex flex-col gap-[10px]">
					<h4 className="text-dark font-roboto text-xl font-bold leading-[140%]">Almonnd</h4>
					<div className="flex ">
						<h6 className="text-secondary font-roboto text-base font-normal leading-[140%]">
							40 Acres
						</h6>
						<div className="h-[20px] border-r border-[#E9ECEF] mx-[20px]"></div>
						<h6 className="text-secondary font-roboto text-base font-normal leading-[140%]">
							Polka
						</h6>
					</div>
				</div>
			</div>
			<div className="flex gap-[10px] items-center mt-[25px] border-b border-[#E9ECEF] pb-[20px] mb-[20px]">
				<FmdGoodOutlinedIcon color="primary" />
				<p className="text-secondary font-roboto text-sm font-normal leading-[140%]">
					1 ალექსანდრე იოსელიანის II შესახვევი, Tbilisi, Georgia
				</p>
				<div className="rounded-[12px] bg-light-grey">
					<IconButton classes={{ root: 'rounded-[12px]' }} aria-label="delete">
						<PublicOutlinedIcon />
					</IconButton>
				</div>
			</div>

			<div className="flex flex-col gap-[20px] pb-5 border-b border-[#E9ECEF pb-[20px] mb-[20px]">
				<h6 className="text-dark font-roboto text-base font-bold leading-[140%]">
					{t('additional-information')}
				</h6>
				<div className="flex flex-col md:flex-row">
					<div className="w-full md:w-1/2">
						{checkboxFields.slice(0, 4).map((field) => (
							<div key={field.name}>
								<div className="flex mb-[15px] items-center gap-[10px]">
									{field.checked ? <CheckIcon /> : <ClearIcon />}
									<p className="text-secondary font-roboto text-base font-normal leading-[140%]">
										{field.label === 'irrigation_system' && field.checked ? (
											<span className="text-secondary font-roboto text-base font-normal leading-[140%] ">
												Irrigation system
											</span>
										) : (
											<span className="text-secondary font-roboto text-base font-normal leading-[140%] ">
												{t(`myFarm.${field.label}`)}
											</span>
										)}
									</p>
								</div>
							</div>
						))}
					</div>
					<div className="w-full md:w-1/2 ">
						{checkboxFields.slice(4).map((field) => (
							<div key={field.name} className="flex mb-[15px] items-center gap-[10px]">
								{field.checked ? <CheckIcon /> : <ClearIcon />}
								<p className="text-secondary font-roboto text-base font-normal leading-[140%]">
									{t(`myFarm.${field.label}`)}
								</p>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="flex flex-col gap-[10px]">
				<h6 className="text-dark roboto-bold text-[16px] leading-normal">{t('attachments')}</h6>
				{data.files.map((file, index) => (
					<div className="flex gap-[10px]" key={index}>
						<img src={getIcon(file.type)} alt={file.type} />
						<span className="text-secondary roboto-regular text-[16px] leading-normal underline">
							{file.name}
						</span>
					</div>
				))}
			</div>
			<div className="w-full h-[1px] bg-light"></div>
			<div className="flex flex-wrap gap-[10px]">
				{data.resources.map((resource, index) => (
					<div
						className="group relative rounded-[12px] w-[77px] h-[77px] shadow-custom-button cursor-pointer"
						key={index}
					>
						<img
							className="w-full h-full rounded-[12px] object-cover"
							src={resource.name}
							alt={`resource-${index}`}
						/>
						<div className="absolute inset-0 bg-[rgba(3,136,119,0.7)] rounded-[12px] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
							<ZoomInIcon className="text-white text-[36px]" />
						</div>
					</div>
				))}
			</div>
			<div className="w-full h-[1px] bg-light"></div>
			<div className="flex flex-col gap-[10px]">
				<h6 className="text-dark roboto-bold text-[16px] leading-normal">{t('farmProblem')}</h6>
				<h6 className="text-secondary roboto-regular text-[16px] leading-normal">
					{t('pestInfestation')}
				</h6>
			</div>
			<div className="w-full h-[1px] bg-light"></div>
			<div className="flex flex-col gap-[10px]">
				<h6 className="text-dark roboto-bold text-[16px] leading-normal">
					{t('communicationLanguage')}
				</h6>
				<div className="flex gap-[10px] items-center">
					<img className="w-[24px] h-[24px]" src={userIcon} alt="userIcon" />
					<div className="flex gap-[10px] items-center">
						<Chip
							label={'English'}
							variant="outlined"
							sx={{
								width: 'max-content',
								borderRadius: '8px',
								border: '1px solid #F8F9FA',
								backgroundColor: '#F8F9FA',
								padding: '1px 10px',
								color: '#7B809A',
								fontFamily: 'Roboto',
								fontSize: '16px',
								fontStyle: 'normal',
								fontWeight: 400,
								lineHeight: '140%',
								height: '24px',
								textTransform: 'camelcase',
								'& .MuiChip-label': {
									padding: 0,
								},
							}}
						/>
					</div>
				</div>
			</div>
			<div className="w-full h-[1px] bg-light"></div>
			{!hideActions && (
				<div className="flex gap-[20px] justify-end max-sm:justify-center">
					<Button
						type="submit"
						variant="outlined"
						onClick={() => navigateWithLanguage('/specialist/chats/individual-chats')}
						sx={{
							padding: '10px 20px',
							fontWeight: '700',
							fontSize: '14px',
							color: '#7B809A',
							border: 'unset',
							boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
							'@media (max-width: 375px)': {
								padding: '10px',
							},
						}}
					>
						<QuestionAnswerOutlinedIcon className="mr-[10px] text-secondary" />
						<span className="text-dark">{t('startChaBtn')}</span>
					</Button>
					<Button
						type="submit"
						variant="contained"
						sx={{
							padding: '10px 20px',
							fontWeight: '700',
							fontSize: '14px',
							'@media (max-width: 375px)': {
								padding: '10px',
							},
						}}
						onClick={handleSendOfferClick}
					>
						{t('sendOffer')}
						<KeyboardArrowRightIcon />
					</Button>
					{/* TEMP */}
					<Button
						type="submit"
						variant="contained"
						onClick={handleReSendOfferClick}
						sx={{
							padding: '10px 20px',
							fontWeight: '700',
							fontSize: '14px',
							'@media (max-width: 375px)': {
								padding: '10px',
							},
						}}
					>
						{t('reSendOffer')}
						<KeyboardArrowRightIcon />
					</Button>
				</div>
			)}
			<GeneralMuiModal
				open={isModalOpen}
				onClose={handleCloseModal}
				title={t('sendAnOffer')}
				styles={{
					paperStyle: { width: '500px' },
					actionsStyle: { justifyContent: 'space-between' },
				}}
				content={
					<div className="flex flex-col gap-[18px]">
						<p className="text-secondary roboto-regular text-[16px] leading-normal">
							{t('farmerKnow')}
						</p>
						<>
							<FormControlLabel
								name="price_checked"
								control={<Checkbox sx={{ padding: '0 10px' }} onChange={formik.handleChange} />}
								sx={{ display: 'flex', alignItems: 'flex-start' }}
								label={
									<span className="text-dark roboto-regular text-base leading-normal">20 EUR</span>
								}
							/>
							{formik.values.price_checked && (
								<>
									<div className="flex gap-[20px] items-center ml-[30px]">
										<div className="flex flex-col gap-[5px]">
											<span className="text-secondary roboto-regular text-[11px] leading-normal">
												{t('netAmount')}
											</span>
											<span className="text-dark roboto-regular text-[16px] leading-normal">
												16.40
											</span>
										</div>
										<div className="flex flex-col gap-[5px]">
											<span className="text-secondary roboto-regular text-[11px] leading-normal">
												{t('netAmount')}
											</span>
											<span className="text-secondary roboto-regular text-[16px] leading-normal">
												16.40
											</span>
										</div>
										<CustomTooltip
											placement="top"
											title={
												<div className="flex items-start justify-start w-full gap-[10px] cursor-pointer">
													<img className="mr-[10px]" src={info} alt="" />
													<p className="roboto-regular text-[16px] leading-[140%]">
														{t('expertiseNoCharge')}
													</p>
												</div>
											}
										>
											<img className="ml-[5px] pointer" src={info} alt="" />
										</CustomTooltip>
									</div>
									<div className="relative">
										<TextField
											maxRows={4}
											multiline
											aria-label="maximum height"
											placeholder={t('totalFee')}
											value={comment}
											onChange={handleCommentChange}
											sx={{
												height: '130px',
												borderRadius: '8px',
												background: '#FFF',
												width: '100%',
												'& .MuiInputBase-root': {
													height: '100%',
													display: 'flex',
													alignItems: 'flex-start',
													marginLeft: '30px',
												},
											}}
										/>
										<div className="absolute bottom-[16px] right-[43px] text-secondary">
											{comment.length}/{maxChars}
										</div>
									</div>
								</>
							)}
						</>
						<>
							<FormControlLabel
								name={'area_checked'}
								control={
									<Checkbox sx={{ padding: '10px 10px 0 10px' }} onChange={formik.handleChange} />
								}
								sx={{ display: 'flex', alignItems: 'flex-start' }}
								label={
									<div className="flex gap-[10px]">
										<div className="w-[100px]">
											<TaInput
												required
												id="crop_area"
												label={t('myFarm.crop_area')}
												size="small"
												type="number"
												value={formik.values.count as any}
											/>
										</div>
										<div className="w-[100px]">
											<TaAutocomplete
												required
												onChange={(event, value) => formik.setFieldValue('name', value)}
												options={currencyOptions}
												getOptionLabel={(option) => option.name}
												label={t('unit')}
												value={formik.values.name || null}
											/>
										</div>
									</div>
								}
							/>
							{formik.values.area_checked && (
								<>
									<div className="flex gap-[20px] items-center ml-[30px]">
										<div className="w-[100px]">
											<TaInput
												required
												id="crop_area"
												label={t('netAmount')}
												size="small"
												type="number"
												value={'20.50'}
											/>
										</div>
										<div className="w-[100px]">
											<TaInput
												required
												id="crop_area"
												label={t('serviceFee')}
												size="small"
												type="number"
												value={'4.5'}
											/>
										</div>
										<CustomTooltip
											placement="top"
											title={
												<div className="flex items-start justify-start w-full gap-[10px] cursor-pointer">
													<img className="mr-[10px]" src={info} alt="" />
													<p className="roboto-regular text-[16px] leading-[140%]">
														{t('expertiseNoCharge')}
													</p>
												</div>
											}
										>
											<img className="ml-[5px] pointer" src={info} alt="" />
										</CustomTooltip>
									</div>
									<div className="relative">
										<TextField
											maxRows={4}
											multiline
											aria-label="maximum height"
											placeholder={t('totalFee')}
											value={comment}
											onChange={handleCommentChange}
											sx={{
												height: '130px',
												borderRadius: '8px',
												background: '#FFF',
												width: '100%',
												'& .MuiInputBase-root': {
													height: '100%',
													display: 'flex',
													alignItems: 'flex-start',
													marginLeft: '30px',
												},
											}}
										/>
										<div className="absolute bottom-[16px] right-[43px] text-secondary">
											{comment.length}/{maxChars}
										</div>
									</div>
								</>
							)}
						</>
						<>
							<FormControlLabel
								name="consultation_checked"
								control={<Checkbox sx={{ padding: '0 10px' }} onChange={formik.handleChange} />}
								sx={{ display: 'flex', alignItems: 'flex-start' }}
								label={
									<div className="flex gap-[10px]">
										<Chip label={t('freeConsultations')} variant="outlined" sx={statusChipStyle} />
										<CustomTooltip
											placement="top"
											title={
												<div className="flex items-start justify-start w-full gap-[10px]">
													<img className="mr-[10px]" src={info} alt="" />
													<p className="roboto-regular text-[16px] leading-[140%]">
														{t('expertiseNoCharge')}
													</p>
												</div>
											}
										>
											<img className="ml-[5px] pointer" src={info} alt="" />
										</CustomTooltip>
									</div>
								}
							/>
							{formik.values.consultation_checked && (
								<>
									<div className="relative">
										<TextField
											maxRows={4}
											multiline
											aria-label="maximum height"
											placeholder={t('totalFee')}
											value={comment}
											onChange={handleCommentChange}
											sx={{
												height: '130px',
												borderRadius: '8px',
												background: '#FFF',
												width: '100%',
												'& .MuiInputBase-root': {
													height: '100%',
													display: 'flex',
													alignItems: 'flex-start',
													marginLeft: '30px',
												},
											}}
										/>
										<div className="absolute bottom-[16px] right-[43px] text-secondary">
											{comment.length}/{maxChars}
										</div>
									</div>
								</>
							)}
						</>
					</div>
				}
				actions={
					<>
						<Button
							type="submit"
							variant="outlined"
							onClick={() => navigateWithLanguage('/specialist/chats/individual-chats')}
							sx={{
								padding: '10px 20px',
								fontWeight: '700',
								fontSize: '14px',
								color: '#7B809A',
								border: 'unset',
								boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
								'@media (max-width: 375px)': {
									padding: '10px',
								},
							}}
						>
							<QuestionAnswerOutlinedIcon className="mr-[10px]" />
							<span className="text-dark">{t('startChaBtn')}</span>
						</Button>
						<Button
							type="submit"
							variant="contained"
							sx={{
								padding: '10px 20px',
								fontWeight: '700',
								fontSize: '14px',
								'@media (max-width: 375px)': {
									padding: '10px',
								},
							}}
							onClick={handleCloseModal}
						>
							{t('sendOffer')}
							<KeyboardArrowRightIcon />
						</Button>
					</>
				}
			/>
			{isPaymentCardOpen && (
				<PaymentCard open={isPaymentCardOpen} onClose={handleClosePaymentCard} />
			)}
		</div>
	);
};
